export default __webpack_public_path__ + "static/media/carousel6.013a4f0d.jpg";